import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

export function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div className="loader" style={{ minHeight: "100vh" }}><div className="spinner" /></div>;
  if (!user) return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  return children;
}

export function AdminRoute({ children }) {
  const { user, profile, loading } = useAuth();
  const location = useLocation();
  const STAFF_ROLES = ["admin", "web_admin", "accounts"];
  if (loading) return <div className="loader" style={{ minHeight: "100vh" }}><div className="spinner" /></div>;
  if (!user) return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  if (!STAFF_ROLES.includes(profile?.role)) return <Navigate to="/" replace />;
  return children;
}

export function BusinessRoute({ children }) {
  const { user, profile, loading } = useAuth();
  if (loading) return <div className="loader" style={{ minHeight: "100vh" }}><div className="spinner" /></div>;
  if (!user) return <Navigate to="/login" replace />;
  if (profile?.role !== "business" && profile?.role !== "admin") return <Navigate to="/" replace />;
  return children;
}
